
import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-hero">
        <div className="container">
          <span className="policy-badge">Privacy Policy</span>
          <h1>Your Privacy Matters To Us</h1>
          <p>
            This Privacy Policy explains how we collect, use, store, and protect
            your personal information when you use our website, browse products,
            or place an order with us.
          </p>
        </div>
      </div>

      <div className="container policy-content">
        <div className="policy-card">
          <h2>Information We Collect</h2>
          <p>
            We may collect personal details such as your name, email address,
            phone number, shipping address, billing address, and order details
            when you use our website or place an order.
          </p>
          <p>
            We may also collect technical information such as browser type, IP
            address, device details, and browsing activity for analytics,
            security, and performance improvement purposes.
          </p>
        </div>

        <div className="policy-card">
          <h2>How We Use Your Information</h2>
          <p>
            We use your information to process orders, manage payments, arrange
            shipping, provide customer support, and send order-related updates.
          </p>
          <p>
            We may also use certain information to improve our website,
            personalize your experience, prevent fraud, and communicate offers
            or updates where legally permitted.
          </p>
        </div>

        <div className="policy-card">
          <h2>Payment Information</h2>
          <p>
            Payment transactions may be processed through trusted third-party
            payment gateways. We do not store full card details on our own
            servers unless explicitly stated otherwise.
          </p>
          <p>
            Payment providers may collect and process transaction-related data
            according to their own privacy and security policies.
          </p>
        </div>

        <div className="policy-card">
          <h2>Cookies & Tracking</h2>
          <p>
            We may use cookies and similar technologies to remember preferences,
            improve site performance, understand user behavior, and support core
            website functionality.
          </p>
          <p>
            You can usually control or disable cookies through your browser
            settings, though some parts of the website may not function properly
            if cookies are disabled.
          </p>
        </div>

        <div className="policy-card">
          <h2>Sharing Of Information</h2>
          <p>
            We may share your information only with service providers and
            partners who help us operate the website, process payments, fulfill
            orders, deliver shipments, or comply with legal obligations.
          </p>
          <p>
            We do not sell your personal information to third parties for
            unauthorized use.
          </p>
        </div>

        <div className="policy-card">
          <h2>Data Security</h2>
          <p>
            We take reasonable technical and organizational measures to protect
            your data from unauthorized access, misuse, loss, or disclosure.
          </p>
          <p>
            However, no internet-based system can be guaranteed to be completely
            secure, and you share information with us at your own risk.
          </p>
        </div>

        <div className="policy-card">
          <h2>Data Retention</h2>
          <p>
            We retain personal information for as long as necessary to provide
            services, comply with legal obligations, resolve disputes, and
            enforce our agreements.
          </p>
          <p>
            When data is no longer required, we may delete or anonymize it
            according to our internal retention practices.
          </p>
        </div>

        <div className="policy-card">
          <h2>Your Rights</h2>
          <p>
            Depending on your location and applicable laws, you may have rights
            related to accessing, correcting, updating, or deleting your
            personal information.
          </p>
          <p>
            You may also be able to withdraw consent for certain communications
            or request clarification about how your information is processed.
          </p>
        </div>

        <div className="policy-card">
          <h2>Children’s Privacy</h2>
          <p>
            Our website is not intended for children without appropriate
            supervision, and we do not knowingly collect personal information
            from minors in violation of applicable law.
          </p>
        </div>

        <div className="policy-card">
          <h2>Policy Updates</h2>
          <p>
            We may update this Privacy Policy from time to time to reflect
            changes in our business, technology, legal requirements, or service
            practices.
          </p>
          <p>
            Updated versions will be posted on this page with the latest
            effective date where applicable.
          </p>
        </div>

        <div className="policy-card">
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy or your personal
            information, please contact us through the support or contact details
            available on our website.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;